import { render, staticRenderFns } from "./AllPersonList.vue?vue&type=template&id=3bce92e0&"
import script from "./AllPersonList.vue?vue&type=script&lang=js&"
export * from "./AllPersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports